export default __webpack_public_path__ + "static/media/swissdevjobs.99ff1dac.png";